import playSound from './play-sound';

(function($) {
    jQuery.fn.extend({
        propAttr: $.fn.prop || $.fn.attr
    });

    $.widget("ca.caCheckinUserPicker", $.ui.autocomplete, {
        options: {
            url : '/layout/user-autocomplete',
            data: {},
            limit : 10,
            source: function(request, response) {
                var self = this;
                var allData = $.extend({}, this.options.data);
                allData.limit = this.options.limit;
                allData.input = request.term;
                allData.alsoSearchInOtherServices = true;
                var codeRegExp = this.options.codeRegExp;

                $.ajax({
                    url: this.options.url,
                    type : 'POST',
                    dataType: "json",
                    data: allData,
                    success: function(data) {
                        var countUsers = Array.isArray(data) ? data.length : data.size();

                        if(!countUsers && allData.noResultsAlert && allData.input.match(codeRegExp)){
                            playSound.playFail();
                            var accessCardErrorMessage = 'This access card # does not exist.';
                            if(self.options.advanceSearch === 1){
                                accessCardErrorMessage = 'This phone number or access card # does not exist.';
                            }

                            $.caAlertCallback(
                                '<div class="ca-access-card-error-text">'+accessCardErrorMessage+'<div>',
                                "Warning!",
                                function () {
                                    self.element.trigger('focus');
                                },
                                {
                                    className: "ca-access-card-error",
                                    fade: true
                                }
                            );

                            // CA-6677
                            // we need to execute that instantly without waiting someone to click "x" for popup
                            $("#checkinmember").val('');
                        }

                        data[countUsers] = {id : '', maintext : '', subtext : '', userpic : '', value : ''};
                        response($.map(data, function(item) {
                            item.value = item.name;
                            return item;
                        }));
                    }
                });
            },
            item : null,
            items : [],
            codeRegExp : /^([^ ]*[0-9]+[^ ]*)$|^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,   // doesn't contain any space and does contain at least one digit
            idFieldName : null,
            changeable: true,
            showCreateButton : true,
            showCreateGhostButton : false,
            notFoundText: '',
            hint : 'Select a Client',
            doNotShow: [],
            parent: null,
            placeholder : 'Select a Client',
            showPlaceholder : true,
            elementEnterPress: true,
            multi: false,
            onLockAction : function() {},
            onBeforeLockAction: function() {},
            onUnlockAction: function() {},

            focus: function (event, ui) {
                if (ui.item == undefined) {
                    return false;
                }

                return $.ui.autocomplete.prototype._trigger.call(this, 'focus', event, ui);
            }
        },

        _create: function() {
            var self = this;
            var options = self.options;

            if (options.data.alsoFindByCode) {
                self.enterPressed = false;
                this.options.search = function () {
                    var text = self.element.val();

                    if (text.match(self.options.codeRegExp) && !self.enterPressed) {
                        options.items = [];
                        return false;
                    }
                };
                this.element.on('keydown', function (event) {
                    if (event.key === 'Enter') {
                        var text = self.element.val();
                        //clear items
                        self.close();

                        //remember that enter was pressed and clear this flag when we get suggestions
                        self.enterPressed = true;
                        $.ui.autocomplete.prototype.search.call(self, text);
                    }
                });
            }

            if (self.options.showCreateGhostButton) {
                var _this = this;
                this.element.on('blur', function() {
                    if($('[name="'+ _this.options.idFieldName +'"]').val() == '') {
                        if(!_this.guestAdded) {
                            $(_this.element).val('');
                        }
                    }
                });
            }

            $.ui.autocomplete.prototype._create.call(this);

            if (options.showPlaceholder && !options.multi) {
                $(this.element).bind('cacheckinuserpickerselect', function(event, obj) {
                    self._lock(obj.item);
                });
            }

            this.element.on('keypress', function(e) {
                if (options.items && e.keyCode == 13 && options.items.hasOwnProperty(1) && options.elementEnterPress) {
                    self.setItem(options.items[0]);
                    options.items = [];
                }
            });

            this.element.val(this.options.placeholder);

            this.element.on('click', function(){
                $(this).trigger('focus');
            });

            this.element.on('focus', function() {
                if (self.options.placeholder == $(this).val()) {
                    $(this).val('');
                }
            });
            this.element.on('blur', function() {
                if ($(this).val().length == 0) {
                    $(this).val(self.options.placeholder);
                }
            });

            if (!$.isEmptyObject(this.options.item)) {
                this.setItem(this.options.item);
            }

            self.setChangeable(options.changeable);

            if (options.showCreateButton) {
                $(self.element).caCreateNewClient();
            }
        },

        _renderItem : function(ul, item) {
            var li = $('<li></li>').data('item.autocomplete', item),
                a = $('<a></a>').appendTo(li);

            var description = (item.description == undefined) ? '' : item.description;

            if (item.isActive != undefined && item.isActive == true) {
                li.addClass('autocomplete-active');
            } else if (item.isStaff != undefined && item.isStaff == true) {
                li.addClass('autocomplete-staff');
            } else if (item.isExpired != undefined && item.isExpired == true) {
                li.addClass('autocomplete-inactive');
            } else if (item.isNotMember != undefined && item.isNotMember == true){
                li.addClass('autocomplete-not-members');
            }

            if (item.reciprocal !== undefined && item.reciprocal === true) {
                li.addClass('autocomplete-reciprocal');
            }

            var nameWithHighlightedTerm = item.name;
            if (item.name) {
                nameWithHighlightedTerm = (item.highlightLabel != undefined && item.highlightLabel.length > 0)
                    ? item.highlightLabel
                    : item.name.replace(new RegExp(this.term.trim(), "gi"), '<span class="user-picker-highlighted" >$&</span>');
            }

            $('<img src="'+ item.userpic +'" />' +
              '<p class="user-picker-name">' + nameWithHighlightedTerm + '&nbsp;</p>' +
              '<p class="user-picker-description">' + description + '&nbsp;</p>').appendTo(a);

            li.appendTo(ul);

            return li;
        },

        _suggest: function(items) {
            var self = this;
            self.options.items = items;

            if (self.options.data.alsoFindByCode && items.hasOwnProperty(1) && !items.hasOwnProperty(2) && items[0].byContractNum == true) { //only 1 element found
                if (self.enterPressed == true) {
                    self.setItem(items[0]);
                    self.options.items = [];
                }

                //clear enter was pressed flag
                self.enterPressed = false;
                return false;
            }
            //clear enter was pressed flag
            self.enterPressed = false;

            $.ui.autocomplete.prototype._suggest.call(this, items);

            var menu = this.menu.element;
            menu.find('li:last').remove();

            menu.addClass('ca-user-picker-menu').removeClass('ui-widget-content');
            menu.find('li a').removeClass('ui-corner-all');
            menu.find('img').addClass('ui-corner-all');

            if (self.options.showCreateButton) {
                menu.css('min-width', '205px');
                $('<li class="ui-menu-item create-new-client"><a href="#"><div><div>Create New Client</div></div></a></li>').appendTo(menu).find('a').on('click', function() {
                    $(self.element).caCreateNewClient('setName', self.element.val()).caCreateNewClient('open');
                    self.close();
                    return false;
                }).hover(function () {return false;}, function () {return false;});
            }

            if (self.options.showCreateGhostButton) {
                menu.css('min-width', '205px');
                $('<li class="ui-menu-item create-new-client"><a href="#"><div><div>Add Guest</div></div></a></li>').appendTo(menu).find('a').on('click', function() {
                    self.guestAdded = true;

                    //need to add <p>, to remove all tags with $(content).text()
                    var content = '<p>' + self.element.val() + '</p>';
                    var text = $(content).text();
                    self.element.val(text); //update posted value
                    self._lock({name: text, id: ''});
                    self.close();
                    return false;
                }).hover(function () {return false;}, function () {return false;});
            }

            if (self.options.notFoundText && !items.hasOwnProperty(1)) {
                $('<li class="item-not-found">' + self.options.notFoundText + '</li>').appendTo(menu);
            }

            if (menu.find('li.ui-menu-item').length == 0 && !self.options.notFoundText) {
                menu.hide();
            }
            self.options.items = [];
        },

        // set item from the outside
        setItem: function(item, runTrigger) {
            this.element.val(item.name);
            this.selectedItem = item;

            if (runTrigger == undefined || runTrigger == true) {
                this._trigger("select", {}, {item: item});
            }
        },

        setItemChange: function(item, runTrigger) {
            this.element.val(item.name);
            this.selectedItem = item;

            if (runTrigger == undefined || runTrigger == true) {
                this._trigger("change", {}, {item: item});
            }
        },

        // get item from the outside
        getItem: function() {
            return this.selectedItem ? this.selectedItem : {} ;
        },

        clearItem: function(runTrigger) {
            this.selectedItem = {};
            this._unlock(runTrigger);
        },

        // Sets userpicker to 'user selected' mode.
        _lock: function(item) {
            if (!item) {
                item = this.selectedItem;
            }

            if (!this._trigger('onBeforeLockAction', {}, {item: item})) {
                return false;
            }

            var text = (item == undefined) ? '' : item.name;

            if (this.options.idFieldName != null) {
                $('[name="'+ this.options.idFieldName +'"]').val(item.id);
            }

            this._showPlaceholder(text);
            this._trigger('onLockAction');
        },

        // Unlocks userpicker from 'user selected' mode
        _unlock: function(runTrigger) {
            var self = this;

            var triggerResult = true;
            if (runTrigger != undefined && runTrigger) {
                var triggerResult = this._trigger("deselect", {}, {item: this.selectedItem});
            }
            if (triggerResult) {
                this._hidePlaceholder();
                this.element.select().val('').trigger('focus');
                this.selectedItem = null;
                this.selected = false;

                if (this.options.idFieldName != null) {
                    $('[name="'+ this.options.idFieldName +'"]').val('');
                }
                this._trigger('onUnlockAction');
            }

//            $(this.element).bind('causerpickerselect', function(event, obj) {
//                self._lock(obj.item);
//            });
        },

        _showPlaceholder : function(text) {
            if (!this.placeholder){
                var self = this;
                this._placeholderText = $('<span>' + text + '</span>');
                this._cross = $('<a class="ca-user-picker-selected-cancel-cross"></a>');

                this._cross.on('click', function() {
                    self._unlock();
                });

                this.placeholder = $('<div></div>')
                    .addClass(this.element.attr('class'))
                    .addClass('ca-user-picker-selected')
                    .append(this._cross)
                    .append(this._placeholderText)
                    .insertAfter(this.element)

                this.placeholder.width(this.element.width());
                this.placeholder.height(this.element.height());
            } else {
                this._placeholderText.text(text);
            }

            this.element.hide();
            this.placeholder.show();
         },

        _hidePlaceholder: function() {
            this.element.show();
            if (this.placeholder) {
                this.placeholder.hide();
            }
        },

        isSelected: function() {
            return this.selected;
        },

        setChangeable: function(changeable) {
            this.options.changeable = changeable ? true : false;

            if (this._cross) {
                this._cross.toggle(this.options.changeable);
            }
        },

        setOnLockAction: function(callback) {
            this.options.onLockAction = callback;
        },

        setOnBeforeLockAction: function(callback) {
            this.options.onBeforeLockAction = callback;
        },

        setOnUnlockAction: function(callback) {
            this.options.onUnlockAction = callback;
        }
    });
})(jQuery);
